/**
 * Gets the Plans page data
 */

import { put, takeEvery, select } from "redux-saga/effects";
import { ActionType } from "typesafe-actions";
import Cookies from "js-cookie";
import * as actions from "./commonActions";
import { trackAPI, gtmAPI } from "../api";
import { getAnonymousId, pageView } from "../helpers";
import * as GTM from "../../gtm";

import ActionTypes from "./constants";
import { getUtmParams } from "@utils/isRenewal";

const { gtm, track } = actions;

const selector = store => store.proposalDataReducer;
const analyticsSelector = store => store.bikeAnalyticsReducer;
const indexSelector = store => store.indexReducer;

const selectPremiumProposalData = (state: any) =>
  state.proposalPremiumDataReducer ?? {};

function* trackSaga(action: ActionType<typeof actions>) {
  const urlParams = new URLSearchParams(window.location.search);
  const flow = urlParams.get("flow");
  const isAgentPortalFlow = (urlParams.get("lsi_portal_flow") || "") === "true";
  const utmParamsData = getUtmParams();

  const proposalData = yield select(selector);
  const anonymousID = yield getAnonymousId();
  const indexData = yield select(indexSelector);

  const premiumProposalData = yield select(selectPremiumProposalData);
  let analyticsData = yield select(analyticsSelector);

  const policyExpiry = proposalData?.data?.expiry;
  //common massaging from any store need to be merged with analytics to reduce confusion
  analyticsData = {
    ...analyticsData,
    edata: {
      planDisplayName: proposalData?.data?.planDisplayName,
      plan_type: proposalData?.data?.planType,
      premium: premiumProposalData?.price?.gross_premium,
      // this is added for OD status
      is_own_damage_only: proposalData?.data?.check_od_only
    },
    odata: {
      phone: proposalData?.data?.mobileNumber
    }
  };

  const proposalEdata = {
    reg_no: proposalData?.data?.carNumber,
    cc: proposalData?.data?.cc,
    fuel_type: proposalData?.data?.fuelType,
    previous_policy_expired: policyExpiry,
    previous_policy_expired_status:
      policyExpiry === false ? "0" : proposalData?.data?.policyStatus,
    registration_year: proposalData?.data?.registrationYear,
    vehicle_make_model: proposalData?.data?.model,
    vehicle_make: proposalData?.data?.make,
    vehicle_variant: proposalData?.data?.variant,
    previous_policy_source: proposalData?.data?.previousPolicyTypeSource,
    previous_policy_expiry_source: proposalData?.data?.ppedSource
  };

  Object.keys(proposalEdata).forEach(key => {
    proposalEdata[key] ?? delete proposalEdata[key];
  });

  const product = "bike";
  const verifyOtpData = action.payload.ekind === "verify_otp_clicked" ? {} : {};

  try {
    const payload = {
      ...analyticsData,
      ...action.payload,
      edata: {
        anonymousID,
        ga_client_id: "1079354792.1580967007",
        is_js: true,
        platform: indexData.platform,
        googleRecaptcha: indexData.verifyCaptchaData,
        journey:
          proposalData?.data?.isNew || flow === "new" ? "new_bike" : "old_bike",
        ...proposalEdata,
        web_engage: true,
        ...utmParamsData,
        ...verifyOtpData,
        ...analyticsData.edata,
        ...action.payload.edata,
        ...((window.product === "freshBike" || window.product === "newBike") &&
          isAgentPortalFlow && {
            is_advisor_portal_flow: true
          }),
        // ...proposalData
        oid:
          action.payload.okind === "tracker"
            ? Cookies.get("trackerid")
            : proposalData?.parentProposalId || proposalData?.proposalId,
        isBikeMigration: true
      },
      odata: {
        ...analyticsData.odata,
        product,
        url: window.location.href,
        ...action.payload.odata
      },
      app: "NS_React",
      user: "",
      ua: navigator.userAgent,
      tracker: Cookies.get("trackerid"),
      oid:
        action.payload.okind === "tracker"
          ? Cookies.get("trackerid")
          : proposalData?.parentProposalId || proposalData?.proposalId
    };

    // yield getVisitCreated();
    yield trackAPI(payload);
    yield put(track.success(payload));
  } catch (e) {
    console.log("r2d2 error", e);
  }
}

function* gtmSaga(action: ActionType<typeof actions>) {
  try {
    const url = window.location.href;
    yield pageView(url);
    yield gtmAPI({
      ...GTM[action.payload.event],
      ...action.payload.data,
      tracker: Cookies.get("trackerid")
    });
  } catch (e) {
    console.log("gtm error", e);
  }
}

/**
 * Root saga manages watcher life cycle
 */
export default function* analyticsSaga() {
  yield takeEvery(ActionTypes.TRACK, trackSaga);
  yield takeEvery(gtm.TRIGGER, gtmSaga);
}
